import {
  AnnouncementIcon,
  CalendarIcon,
  SendAgainIcon,
  UsersIcon,
} from "@/assets";
import { CustomModal } from "@/components/custom-modal";
import CustomTabs from "@/components/CustomTabs";
import DebouneSearchAnnonvement from "@/components/DebouneSearchAnnonvement";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import {
  DialogClose,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Separator } from "@/components/ui/separator";
import { Skeleton } from "@/components/ui/skeleton";
import { Switch } from "@/components/ui/switch";
import { Textarea } from "@/components/ui/textarea";
import { formattedDate, formattedTime, formatType } from "@/lib/helper";
import { ToastMessage, type } from "@/lib/toastr";
import {
  postAnnouncement,
  getAllNotifications,
  getAnnouncements,
  sendNotification,
  getNotice,
} from "@/services/Settings.service";
import { getUserByName } from "@/services/Users.service";
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import {
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  Loader2,
  MessageSquareDot,
  MoreHorizontal,
  Plus,
  SquarePen,
  SquarePenIcon,
} from "lucide-react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { BsThreeDotsVertical } from "react-icons/bs";
import { VscEye } from "react-icons/vsc";
import Dropzone from "shadcn-dropzone";
import NoticeActions from "./common/NoticeActions";

const Announcements = () => {
  const queryClient = useQueryClient();
  const [image, setImage] = useState(null);
  const [file, setFile] = useState(null);
  const [imageName, setImageName] = useState("");
  const [imageSize, setImageSize] = useState("");
  const [label, setLabel] = useState("");
  const [search, setSearch] = useState("");
  const [value, setValue] = useState("");
  const [selectedValue, setSelectedValue] = useState("");

  const checkSearch = search === "" ? false : true;
  const [isAnnouncementOpen, setIsAnnouncementOpen] = useState(false);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);

  const [typeM, setTypeM] = useState("");

  const mutation = useMutation({
    mutationFn: (data) => postAnnouncement(data),
    mutationKey: ["addAnnouncement"],
    onSuccess: async () => {
      form.reset();
      queryClient.clear();
      setIsAnnouncementOpen(false);
      ToastMessage(type.SUCCESS, "Announcement has been saved successfully");
    },
    onError: (err) => {
      ToastMessage(type.ERROR, err.response.data.message);
    },
  });

  const mutation2 = useMutation({
    mutationFn: (data) => sendNotification(data),
    mutationKey: ["bulk"],
    onSuccess: (res) => {
      queryClient.clear();
      setIsNotificationOpen(false);
      ToastMessage(
        type.SUCCESS,
        "Bulk notification message has been successfully sent"
      );
    },
    onError: (err) => {
      ToastMessage(type.ERROR, err.response.data.message);
    },
  });

  const form = useForm();
  const announceDate = new Date()?.toISOString();

  const onSubmit = async (data) => {
    if (typeM === "notification") {
      await mutation2.mutate({
        title: data?.title,
        message: data?.message,
        customerId: "all",
      });
    }
    if (typeM === "announcement") {
      const formData = new FormData();

      formData.append("title", data?.title);
      formData.append("body", data?.body);
      formData.append("announceDate", announceDate);
      formData.append("image", data?.image);

      await mutation.mutate(formData);
    }
  };

  return (
    <>
      <div className="grid gap-8 p-6">
        <div className="flex items-center gap-4 justify-between">
          <div className="flex-col gap-2">
            <p className="text-2xl font-medium text-primary-3">Marketing</p>
            <p className="text-base text-gray-80">
              Send and Manage push notifications here
            </p>
          </div>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button>
                Send New
                <ChevronDown />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuItem
                onClick={() => {
                  setIsNotificationOpen(true);
                  setTypeM("notification");
                }}
              >
                <span className="flex items-center gap-2 text-xs text-primary-9">
                  <MessageSquareDot />
                  New bulk notification
                </span>
              </DropdownMenuItem>
              <DropdownMenuItem
                onClick={() => {
                  setIsAnnouncementOpen(true);
                  setTypeM("announcement");
                }}
              >
                <span className="flex items-center gap-2 text-xs text-primary-9">
                  <AnnouncementIcon />
                  New announcement
                </span>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
        <div className="container mx-auto">
          <CustomTabs
            tabs={["Bulk Notification", "Announcements", "In-app Notice"]}
            tabData=
            {{
              "Bulk Notification": <Bulk />,
              Announcements: <Announcement />,
              "In-app Notice": <Notice />
            }}
          />
        </div>
      </div>
      <CustomModal
        open={isNotificationOpen}
        onOpenChange={setIsNotificationOpen}
        size="lg"
      >
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="flex flex-col gap-8">
              <DialogHeader className="flex flex-row  w-full p-0 items-center gap-4 bg-off-white-1 py-6 px-8 rounded-t-[16px]">
                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-off-white-3">
                  <AnnouncementIcon />
                </div>
                <div className="flex flex-col ">
                  <DialogTitle className="text-sm font-normal capitalize text-primary-3">
                    Send Bulk Notification
                  </DialogTitle>
                  <DialogDescription className="text-sm">
                    Send a push notification to all users
                  </DialogDescription>
                </div>
              </DialogHeader>

              <div className="flex flex-col gap-4 px-8">
                <Label className="text-xs">Message</Label>

                <FormField
                  control={form.control}
                  name="title"
                  render={({ field }) => {
                    return (
                      <FormItem>
                        <div className="flex flex-col w-full items-star   gap-1.5 border-[1px]  rounded-[8px] px-2 py-2  border-input-border ">
                          <FormLabel htmlFor="title" className="text-xs">
                            Header Text
                          </FormLabel>
                          <FormControl>
                            <Input
                              placeholder="Type your title"
                              className="w-full h-6 p-0 border-none ring-transparent focus-visible:ring-transparent"
                              {...field}
                            />
                          </FormControl>
                        </div>
                      </FormItem>
                    );
                  }}
                />

                <FormField
                  control={form.control}
                  name="message"
                  render={({ field }) => {
                    return (
                      <FormItem>
                        <div className="flex flex-col w-full items-star   gap-1.5 border-[1px]  rounded-[8px] px-2 py-2 h-full border-input-border ">
                          <FormLabel htmlFor="message" className="text-xs">
                            Body Text
                          </FormLabel>
                          <FormControl>
                            <Textarea
                              placeholder="Type your message here."
                              className="w-full p-0 border-none ring-transparent focus-visible:ring-transparent"
                              {...field}
                            />
                          </FormControl>
                        </div>
                      </FormItem>
                    );
                  }}
                />
              </div>
            </div>
            <DialogFooter className="px-6 py-4 flex flex-row justify-between items-center bg-off-white-1 rounded-b-[16px]">
              <DialogClose asChild>
                <Button
                  type="button"
                  variant="ghost"
                  className=" text-primary0 h-12 rounded-[10px] p-[8px 12px] hover:text-primary0"
                >
                  <ChevronLeft /> Cancel
                </Button>
              </DialogClose>
              <Button
                type="submit"
                className="bg-gradient-to-r from-primary to-primary-2 h-12 rounded-[10px] p-[8px 12px]"
                onClick={() => setTypeM("notification")}
                disabled={
                  !form.formState.isDirty ||
                  !form.formState.isValid ||
                  form.formState.isSubmitting ||
                  mutation2?.isPending
                }
              >
                {mutation2?.isPending && (
                  <Loader2 className="text-white animate-spin" />
                )}
                Send Notification <ChevronRight />
              </Button>
            </DialogFooter>
          </form>
        </Form>
      </CustomModal>
      <CustomModal
        open={isAnnouncementOpen}
        onOpenChange={setIsAnnouncementOpen}
        size="lg"
      >
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="flex flex-col gap-8">
              <DialogHeader className="flex flex-row  w-full p-0 items-center gap-4 bg-off-white-1 py-6 px-8 rounded-t-[16px]">
                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-off-white-3">
                  <AnnouncementIcon />
                </div>
                <div className="flex flex-col ">
                  <DialogTitle className="text-sm font-normal capitalize text-primary-3">
                    Send a New Announcement
                  </DialogTitle>
                  <DialogDescription className="text-sm">
                    Send a push notification to all or some Treasura users
                  </DialogDescription>
                </div>
              </DialogHeader>

              <div className="flex flex-col gap-4 p-8 pt-0">
                <Label className="text-xs">Message</Label>

                <FormField
                  control={form.control}
                  name="title"
                  render={({ field }) => {
                    return (
                      <FormItem>
                        <div className="flex flex-col w-full items-star   gap-1.5 border-[1px]  rounded-[8px] px-2 py-2  border-input-border ">
                          <FormLabel htmlFor="title" className="text-xs">
                            Header Text
                          </FormLabel>
                          <FormControl>
                            <Input
                              placeholder="Type your title"
                              className="w-full h-6 p-0 border-none ring-transparent focus-visible:ring-transparent"
                              {...field}
                            />
                          </FormControl>
                        </div>
                      </FormItem>
                    );
                  }}
                />

                <FormField
                  control={form.control}
                  name="body"
                  render={({ field }) => {
                    return (
                      <FormItem>
                        <div className="flex flex-col w-full items-star   gap-1.5 border-[1px]  rounded-[8px] px-2 py-2 h-full border-input-border ">
                          <FormLabel htmlFor="message" className="text-xs">
                            Body Text
                          </FormLabel>
                          <FormControl>
                            <Textarea
                              placeholder="Type your message here."
                              className="w-full p-0 border-none ring-transparent focus-visible:ring-transparent"
                              {...field}
                            />
                          </FormControl>
                        </div>
                      </FormItem>
                    );
                  }}
                />

                <FormField
                  control={form.control}
                  name="image"
                  render={({ field: { value, onChange, ...fieldProps } }) => {
                    return (
                      <FormItem>
                        <div className="flex flex-col w-full items-star  gap-1.5 border-[1px]  rounded-[8px] px-2 py-2 h-full border-input-border ">
                          <FormLabel htmlFor="image" className="text-xs">
                            Choose image
                          </FormLabel>
                          <FormControl>
                            <Input
                              type="file"
                              className="w-full h-6 p-0 border-none ring-transparent focus-visible:ring-transparent"
                              {...fieldProps}
                              accept="image/*,"
                              onChange={(event) =>
                                onChange(
                                  event?.target?.files && event.target.files[0]
                                )
                              }
                            />
                          </FormControl>
                        </div>
                      </FormItem>
                    );
                  }}
                />
              </div>
            </div>
            <DialogFooter className="px-6 py-4 flex flex-row justify-between items-center bg-off-white-1 rounded-b-[16px]">
              <DialogClose asChild>
                <Button
                  type="button"
                  variant="ghost"
                  className=" text-primary0 h-12 rounded-[10px] p-[8px 12px] hover:text-primary0"
                >
                  <ChevronLeft /> Cancel
                </Button>
              </DialogClose>
              <Button
                type="submit"
                className="bg-gradient-to-r from-primary to-primary-2 h-12 rounded-[10px] p-[8px 12px]"
                disabled={
                  !form.formState.isDirty ||
                  !form.formState.isValid ||
                  form.formState.isSubmitting ||
                  mutation?.isPending ||
                  !form.formState?.dirtyFields?.image ||
                  !form.formState?.dirtyFields?.title ||
                  !form.formState?.dirtyFields?.body
                }
              >
                {mutation?.isPending && (
                  <Loader2 className="text-white animate-spin" />
                )}
                Send Announcement <ChevronRight />
              </Button>
            </DialogFooter>
          </form>
        </Form>
      </CustomModal>
    </>
  );
};

export default Announcements;

const Announcement = () => {
  const [filter, setFilter] = useState({
    page: 1,
  });
  const { data, isLoading } = useInfiniteQuery({
    queryKey: ["Announcements"],
    queryFn: async ({ pageParam = filter?.page }) =>
      await getAnnouncements(pageParam),
    getNextPageParam: (lastPage, pages) => {
      if (lastPage.length === 0) return undefined;
      return pages.length + 1;
    },
  });

  const dataArr = data?.pages?.map((page) => page?.data?.data?.data)?.flat();
  return (
    <>
      {isLoading ? (
        <div className="flex justify-center items-center  w-full">
          <Loader2 className="animate-spin text-2xl text-center" />
        </div>
      ) : (
        <div className="grid lg:grid-cols-3 gap-4">
          {dataArr?.map((item) => (
            <Card
              className="flex flex-col gap-4 px-6 py-5 bg-background"
              key={item?.id}
            >
              <CardHeader className="flex flex-row items-center justify-between w-full p-0">
                <CardTitle className="text-sm font-normal capitalize text-primary-3">
                  {item?.title}
                </CardTitle>

                <Popover>
                  <PopoverTrigger>
                    <Button variant="ghost" className="h-0 px-1 py-2">
                      <BsThreeDotsVertical className="text-primary-3" />
                    </Button>
                  </PopoverTrigger>
                  <PopoverContent className="flex flex-col items-start gap-2 w-fit">
                    <CustomModal
                      button={
                        <Button variant="ghost" className="h-0 px-1 py-2">
                          <VscEye /> View More
                        </Button>
                      }
                      size="sm"
                    >
                      <div className="flex flex-col gap-4 px-6 pt-5">
                        <DialogHeader className="flex flex-row items-center justify-between w-full p-0">
                          <DialogTitle className="text-sm font-normal capitalize text-primary-3">
                            {item?.title}
                          </DialogTitle>
                        </DialogHeader>
                        <p className="text-xs text-gray-80 line-clamp-2">
                          {item?.body}
                        </p>
                        <div>
                          <Separator
                            orientation="horizontal"
                            className="h-[1px] bg-border"
                          />

                          <div className="flex gap-4 p-0 pt-4 text-gray-60">
                            <div className="flex items-center gap-2">
                              <CalendarIcon />
                              <span className="text-xs text-gray-60">
                                {formattedDate(item?.announceDate)}{" "}
                                {formattedTime(item?.announceDate)}
                              </span>
                            </div>
                            <div className="flex items-center gap-2">
                              <UsersIcon />

                              <span className="text-xs text-gray-60">
                                All Users
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <DialogFooter className="px-6 py-3 border-t-[1px] flex flex-row justify-between items-center">
                        <DialogClose asChild>
                          <Button
                            type="button"
                            variant="ghost"
                            className=" text-primary0 h-12 rounded-[10px] p-[8px 12px] hover:text-primary0"
                          >
                            <ChevronLeft /> Go Back
                          </Button>
                        </DialogClose>
                        <Button
                          type="button"
                          variant="outline"
                          className=" h-12 rounded-[10px] p-[8px 12px] bg-transparent border-primary border-[1px] text-primary hover:text-primary"
                        >
                          <SendAgainIcon />
                          Send Again
                        </Button>
                      </DialogFooter>
                    </CustomModal>
                    <Button
                      variant="ghost"
                      className="h-0 px-1 py-2 text-primary"
                    >
                      <SendAgainIcon />
                      Send Again
                    </Button>
                  </PopoverContent>
                </Popover>
              </CardHeader>
              <CardContent className="p-0">
                <p className="text-xs text-gray-80 line-clamp-2">
                  {item?.body}
                </p>
              </CardContent>
              <div>
                <Separator
                  orientation="horizontal"
                  className="h-[1px] bg-border"
                />

                <CardFooter className="flex-row gap-4 p-0 pt-4 text-gray-60">
                  <div className="flex items-center gap-2">
                    <CalendarIcon />
                    <span className="text-xs text-gray-60">
                      {formattedDate(item?.announceDate)}{" "}
                      {formattedTime(item?.announceDate)}
                    </span>
                  </div>
                  <span className="flex items-center gap-2">
                    <UsersIcon />

                    <span className="text-xs text-gray-60">All Users</span>
                  </span>
                </CardFooter>
              </div>
            </Card>
          ))}
        </div>
      )}
    </>
  );
};

const Bulk = () => {
  const [filter, setFilter] = useState({});
  const { data, isLoading, isFetching, refetch, hasNextPage, fetchNextPage } =
    useInfiniteQuery({
      queryKey: ["getAllNotifications"],
      queryFn: async ({ pageParam = 1 }) =>
        await getAllNotifications(pageParam, filter),
      getNextPageParam: (lastPage, pages) => {
        if (lastPage.length === 0) return undefined;
        return pages.length + 1;
      },
      refetchIntervalInBackground: true,
      refetchOnMount: "always",
    });

  const dataArr = data?.pages?.map((page) => page.data.data.data).flat();
  const dataArr2 = data?.pages?.map((page) => page.data.data.meta).flat()[0];
  return (
    <>
      {isLoading ? (
        <div className="flex justify-center items-center  w-full">
          <Loader2 className="animate-spin text-2xl text-center" />
        </div>
      ) : (
        <div className="grid lg:grid-cols-3 gap-4">
          {dataArr?.map((item) => (
            <Card
              className="flex flex-col gap-4 px-6 py-5 bg-background"
              key={item?.id}
            >
              <CardHeader className="flex flex-row items-center justify-between w-full p-0">
                <CardTitle className="text-sm font-normal capitalize text-primary-3">
                  {item?.message?.push?.title}
                </CardTitle>

                <Popover>
                  <PopoverTrigger>
                    <Button variant="ghost" className="h-0 px-1 py-2">
                      <BsThreeDotsVertical className="text-primary-3" />
                    </Button>
                  </PopoverTrigger>
                  <PopoverContent className="flex flex-col items-start gap-2 w-fit">
                    <CustomModal
                      button={
                        <Button variant="ghost" className="h-0 px-1 py-2">
                          <VscEye /> View More
                        </Button>
                      }
                      size="sm"
                    >
                      <div className="flex flex-col gap-4 px-6 pt-5">
                        <DialogHeader className="flex flex-row items-center justify-between w-full p-0">
                          <DialogTitle className="text-sm font-normal capitalize text-primary-3">
                            {item?.message?.push?.title}
                          </DialogTitle>
                        </DialogHeader>
                        <p className="text-xs text-gray-80 line-clamp-2">
                          {item?.message?.push?.message}
                        </p>
                        <div>
                          <Separator
                            orientation="horizontal"
                            className="h-[1px] bg-border"
                          />

                          <div className="flex gap-4 p-0 pt-4 text-gray-60">
                            <div className="flex items-center gap-2">
                              <CalendarIcon />
                              <span className="text-xs text-gray-60">
                                {formattedDate(item?.createdAt)}{" "}
                                {formattedTime(item?.createdAt)}
                              </span>
                            </div>
                            <div className="flex items-center gap-2">
                              <UsersIcon />

                              <span className="text-xs text-gray-60">
                                All Users
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <DialogFooter className="px-6 py-3 border-t-[1px] flex flex-row justify-between items-center">
                        <DialogClose asChild>
                          <Button
                            type="button"
                            variant="ghost"
                            className=" text-primary0 h-12 rounded-[10px] p-[8px 12px] hover:text-primary0"
                          >
                            <ChevronLeft /> Go Back
                          </Button>
                        </DialogClose>
                        <Button
                          type="button"
                          variant="outline"
                          className=" h-12 rounded-[10px] p-[8px 12px] bg-transparent border-primary border-[1px] text-primary hover:text-primary"
                        >
                          <SendAgainIcon />
                          Send Again
                        </Button>
                      </DialogFooter>
                    </CustomModal>
                    <Button
                      variant="ghost"
                      className="h-0 px-1 py-2 text-primary"
                    >
                      <SendAgainIcon />
                      Send Again
                    </Button>
                  </PopoverContent>
                </Popover>
              </CardHeader>
              <CardContent className="p-0">
                <p className="text-xs text-gray-80 line-clamp-2">
                  {item?.message?.push?.message}
                </p>
              </CardContent>
              <div>
                <Separator
                  orientation="horizontal"
                  className="h-[1px] bg-border"
                />

                <CardFooter className="flex-row gap-4 p-0 pt-4 text-gray-60">
                  <div className="flex items-center gap-2">
                    <CalendarIcon />
                    <span className="text-xs text-gray-60">
                      {formattedDate(item?.createdAt)}{" "}
                      {formattedTime(item?.createdAt)}
                    </span>
                  </div>
                  <span className="flex items-center gap-2">
                    <UsersIcon />

                    <span className="text-xs text-gray-60">All Users</span>
                  </span>
                </CardFooter>
              </div>
            </Card>
          ))}
        </div>
      )}
    </>
  );
};

const Notice = () => {
  const query = useQuery({
    queryKey: ['notice'],
    queryFn: () => getNotice()
  })
  console.log(query?.data?.data?.data);
  return (
    <div className="h-20 p-6 border-accent border rounded-xl gap-6 flex items-center">
      <div className="w-full grid gap-1">
        {query?.isLoading ?
          <Skeleton className="w-3/5 h-3.5 " /> :
          <h3 className="text-sm text-auth">{query?.data?.data?.data?.title}</h3>
        }
        {query?.isLoading ?
          <Skeleton className="w-full h-3 " /> :
          <p className="text-xs text-gray-80">{query?.data?.data?.data?.content}</p>
        }
      </div>
      <NoticeActions
        data={query?.data?.data?.data}
      />

    </div>
  )
}